import getFetchStatusSelectors from '../../../../selectors/fetchStatuses/HOF/fetchStatusSelectors'


export default getFetchStatusSelectors()()
